import {useEffect} from 'react';

export const SUFIKS_TYTULU = 'Karta Merkury Market';

export const usePageTitle = (tytul: string) => {
    useEffect(() => {
        document.title = `${tytul} – ${SUFIKS_TYTULU}`;
    }, [tytul]);
};
